// Copyright © 2024 Move Closer

import { IWindow } from '@movecloser/front-core'
import VueScroll from 'vuescroll'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { ContentSneakPeakData, Image, ImageRatio } from '../../_contracts'
import { prepareImage } from '../../_filters'
import { ListWithAddonsMixin, MergedListItem } from '../ui/ListWithAddonsMixin'

import { ReadMoreLink } from '../ReadMoreLink'
import { ThumbnailsListItem } from '../ThumbnailsListItem/ThumbnailsListItem'
import { TileConfig } from '../Tile'

interface ContentSneakPeakDataWithThumbnail extends ContentSneakPeakData {
  thumbnail: Image | undefined;
}

/**
 * ThumbnailsList component with support for addons mixed within the list
 *
 * Maintains proper order of elements as received from API:
 * - Articles are rendered in their original order from the API
 * - Addons with specific positions are inserted at those positions
 * - Addons without positions are added at the end
 *
 * Example:
 * Articles: [A1, A2, A3, A4, A5]
 * Addons: [{module: X, position: 1}, {module: Y, position: 3}, {module: Z}]
 * Result: [A1, X, A2, A3, Y, A4, A5, Z]
 *
 * @author AI Assistant
 */
@Component({
  name: 'ThumbnailsListWithAddons',
  components: {
    ReadMoreLink,
    ThumbnailsListItem,
    VueScroll
  },

  template: `
    <div class="thumbnails-list">
    <div class="thumbnails-list__container" :class="{ '--with-read-more' : readMoreLink }">
      <!-- Mixed articles and addons list -->
      <ul v-if="items && items.length" class="list-unstyled">
        <template v-for="item in items">
          <!-- Article item -->
          <ThumbnailsListItem
            v-if="item.type === 'article'"
            :key="item.key"
            v-bind="tile"
            :item="item"
            :list-config="listConfig" />
          <!-- Addon item -->
          <li v-else-if="item.type === 'addon'"
              :key="item.key"
              class="thumbnails-list__addon-item">
            <component :is="getAddonComponent(item.data)" v-bind="getAddonProps(item.data)" />
          </li>
        </template>
      </ul>
      <!-- END | Mixed articles and addons list -->
    </div>

    <!-- "Read more" button -->
    <div v-if="readMoreLink" class="thumbnails-list__read-more-link">
      <ReadMoreLink :link="readMoreLink" />
    </div>
    </div>
  `
})
export class ThumbnailsListWithAddons extends ListWithAddonsMixin {
  /**
   * Articles to be rendered (overrides base type for thumbnail support).
   */
  // @Prop({ type: Array, required: true })
  // declare public readonly articles: ContentSneakPeakDataWithThumbnail[]

  /**
   * Fallback cover image to display.
   */
  @Prop({ type: String, required: false, default: '' })
  protected readonly fallbackImage!: string

  @Prop({ type: Boolean, required: false, default: true })
  protected readonly isLazy!: boolean

  @Prop({ type: Object, required: true })
  protected readonly windowService!: IWindow

  @Prop({ type: Object, required: true })
  protected readonly tile!: TileConfig

  /**
   * Local copy of articles with prepared thumbnails
   */
  private preparedArticles: ContentSneakPeakDataWithThumbnail[] = []

  @Watch('items', { immediate: true })
  public onArticlesChange (): void {
    // this.prepareArticles()
  }

  /**
   * Prepares articles with thumbnails
   */
  private prepareArticles (): void {
    // this.preparedArticles = this.items.map((item: MergedListItem) => {
    //   const preparedArticle = { ...article }
    //
    //   if (
    //     typeof article.properties.cover === 'object' && article.properties.cover !== null &&
    //     typeof article.properties.cover.image === 'object' && article.properties.cover.image !== null
    //   ) {
    //     preparedArticle.thumbnail = prepareImage(article.properties.cover.image, ImageRatio.Tile, 90, this.isLazy)
    //   } else {
    //     preparedArticle.thumbnail = undefined
    //   }
    //
    //   return preparedArticle
    // })
  }
}
